<template>
    <v-layout row wrap>
        <v-tabs dark centered>

            <v-tabs-bar class="grey darken-3">                      
                <v-tabs-slider color="orange"></v-tabs-slider>
                <v-tabs-item href="#tab1" >
                    <v-btn flat class="grey--text">
                        Stammdaten
                    </v-btn>
                </v-tabs-item>
                <v-tabs-item href="#tab2" >
                    <v-btn flat class="grey--text">
                        Logos
                    </v-btn>
                </v-tabs-item>
                <v-tabs-item href="#tab3">
                    <v-btn flat class="grey--text">
                        Typen & Warengruppen
                    </v-btn>

                </v-tabs-item>   
                <v-tabs-slider class="orange"></v-tabs-slider>
            </v-tabs-bar> 


            <v-tabs-items>
                <v-tabs-content id="tab1">
                    <div>
                        <keep-alive>
                            <form-one v-on:submitted="submitForm"></form-one>
                        </keep-alive>
                    </div>
                </v-tabs-content>

                <v-tabs-content id="tab2">
                    <div>
                        <keep-alive>
                            <form-two v-on:submitted="submitForm"></form-two>
                        </keep-alive>
                    </div>
                </v-tabs-content>

                   <v-tabs-content id="tab3">
                    <div>
                        <keep-alive>
                            <form-three v-on:submitted="submitForm"></form-three>
                        </keep-alive>
                    </div>
                </v-tabs-content>

            </v-tabs-items>
        </v-tabs> 
    </v-layout>
</template>

<script>

import formOne from './editMarken_1.vue';
import formTwo from './editMarken_2.vue';
import formThree from './editMarken_3.vue';

export default {
    components: {
        'form-one': formOne,
        'form-two' : formTwo,
        'form-three' : formThree
    },
    data() {
        return {
            
            id: this.$route.params.id    
        }
    }, 
    computed: {
        loading: function() {
            return this.$store.getters.loading
        },
        
    },
    mounted(){
               
        this.$store.dispatch('setMarke', this.id)
        this.$store.dispatch('setTypes')
        this.$store.dispatch('setWarengruppen')
        this.$store.dispatch('setFirmen')
        
           
    },
    methods: {
        submitForm: function(mk) {
            this.$store.commit('setMessagebar', false)
            this.$store.dispatch('putMarke', mk).then((response)=>{ 
                this.$store.dispatch('setMarke', this.id)                
                this.$router.push('/marken')
            })
            this.$store.commit('setMessagebar', true)
        },
    }
    
}
</script>

<style>
    
    
</style>



// WEBPACK FOOTER //
// editMarken.vue?45a3ce84